import React from 'react';
import { FieldError, Controller } from 'react-hook-form';
import PI, { PhoneInputProps } from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

export const ReactPhoneInput: React.FC<PhoneInputProps> =
  (PI as any).default || PI;

const PhonePickerInput: React.FC<{
  control: any;
  id: string;
  error?: FieldError;
}> = ({ control, id, error }) => {
  const errorComponent = error?.message && (
    <p className="italic font-main text-body-sm text-danger-600 mt-1">
      {error.message}
    </p>
  );

  return (
    <div className="relative">
      <Controller
        control={control}
        name={id}
        rules={{ required: true }}
        render={({ field }) => (
          <ReactPhoneInput
            {...field}
            country={'fr'}
            onlyCountries={['fr']}
            countryCodeEditable={false}
            inputStyle={{
              width: '242px',
              height: '44px',
              borderRadius: '0.5rem',
            }}
          />
        )}
      />
      {errorComponent}
    </div>
  );
};

export default PhonePickerInput;
